import { getCookie as getControlledCookie } from '@atlassian/browser-storage-controls';

export function getCookie(): { [key: string]: string };
export function getCookie(key: string): string | undefined;
export function getCookie(key?: string) {
	return key ? getControlledCookie(key) : getControlledCookie();
}
